import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BriefcaseJob } from 'src/app/models/review/briefcase-job.model';
import { KeyHandlerDirective } from '../../../directives/key-handler.directive';
import { UserConfigsService } from '../../../services/user-configs.service';
import { Role } from '../../../models/role.model';

@Component({
    selector: 'lex-create-briefcase',
    templateUrl: './create-briefcase.component.html',
    styleUrls: ['./create-briefcase.component.scss'],
    standalone: false
})
export class CreateBriefcaseComponent extends KeyHandlerDirective {
	briefcase: BriefcaseJob = { title: `Briefcase ${new Date().toLocaleDateString()}` };
	get Role(): typeof Role { return Role; }

	constructor(private dialogRef: MatDialogRef<CreateBriefcaseComponent>, @Inject(MAT_DIALOG_DATA) private data, public userConfigService: UserConfigsService) {
		super();
		this.briefcase.expandToEmailFamily = this.data?.expandEmailFamilySelected;
	}

	ok() {
		this.dialogRef.close(this.briefcase);
	}
}
